import { useFormatDate, wixServerData } from '@wix/package-picker-shared';
import { useCurrentModule } from '../ModuleProvider';
export const SaleDisclaimer = () => {
  var _data$discount;
  const module = useCurrentModule();
  const {
    locale
  } = wixServerData.get();
  const {
    t
  } = module.internals.useTranslations();
  const formatDate = useFormatDate({
    locale
  });
  const {
    data
  } = module.SDK.studioOfferingApiClient.hooks.useFetchOfferingDiscount({});
  if (data != null && (_data$discount = data.discount) != null && _data$discount.discountInfo) {
    if (data != null && data.discount.expiresAt) {
      return t('sale.footer.offer', {
        date: formatDate(data == null ? void 0 : data.discount.expiresAt)
      });
    } else {
      return t('sale.footer.personal_sale_offer');
    }
  }
  return null;
};
//# sourceMappingURL=SaleDisclaimer.js.map